import { Link, useParams, useNavigate } from "react-router-dom";
import {
  FaClock,
  FaQuestionCircle,
  FaCheckCircle,
} from "react-icons/fa";

import {
  useGetEnglishQuizByIdQuery,
} from "../../slices/englishQuizApiSlice";

import {
  useStartEnglishQuizAttemptMutation,
} from "../../slices/englishQuizAttemptApiSlice";


const EnglishQuizStartScreen = () => {
  const { quizId } = useParams();
  const navigate = useNavigate();

  const {
    data: quiz,
    isLoading,
    error,
  } = useGetEnglishQuizByIdQuery(quizId );

  const [
    startEnglishQuizAttempt,
    { isLoading: isStarting },
  ] = useStartEnglishQuizAttemptMutation();


  const handleStartQuiz = async () => {
    try {
      const response =
        await startEnglishQuizAttempt(quizId).unwrap();

      navigate(
        `/english-quiz-attempts/${response.attemptId}/attempt`,
      );

    } catch (error) {
      console.error(
        "Failed to start English quiz:",
        error,
      );
    }
  };


  if (isLoading) {
    return (
      <div className="p-10 text-center">
        Loading quiz...
      </div>
    );
  }


  if (error || !quiz) {
    return (
      <div className="p-10 text-center text-red-600">
        Unable to load English quiz.
      </div>
    );
  }


  return (
    <div className="min-h-screen bg-gray-50 p-6">

      <div className="max-w-4xl mx-auto">

        {/* Back */}

        <Link
          to="/student/english-quizzes"
          className="
            text-blue-600
            mb-5
            inline-block
          "
        >
          ← Back to English Quizzes
        </Link>


        {/* Quiz Card */}

        <div
          className="
            rounded-3xl
            bg-white
            shadow-xl
            p-8
          "
        >

          {/* Quiz Title */}

          <h1 className="text-3xl font-bold text-gray-800">
            {quiz.name}
          </h1>


          {/* Description */}

          <p className="mt-3 text-gray-600">
            {quiz.description ||
              "No description available"}
          </p>


          {/* Quiz Information */}

          <div
            className="
              grid
              md:grid-cols-2
              gap-4
              mt-8
            "
          >

            {/* Duration */}

            <div className="rounded-xl bg-blue-50 p-5">

              <FaClock className="text-blue-600 text-xl" />

              <p className="mt-2 font-semibold">
                Duration
              </p>

              <p>
                {quiz.durationMinutes} minutes
              </p>

            </div>


            {/* Questions */}

            <div className="rounded-xl bg-purple-50 p-5">

              <FaQuestionCircle className="text-purple-600 text-xl" />

              <p className="mt-2 font-semibold">
                Questions
              </p>

              <p>
                {quiz.totalQuestions || "Based on quiz configuration"}
              </p>

            </div>

          </div>


          {/* Information */}

          <div className="mt-8">

            <div
              className="
                rounded-xl
                bg-green-50
                border
                border-green-200
                p-4
                text-green-700
                mb-5
              "
            >

              <FaCheckCircle className="inline mr-2" />

              Your question paper will be generated
              when you start the quiz.

            </div>


            {/* Start Button */}

            <button
              type="button"
              onClick={handleStartQuiz}
              disabled={isStarting}
              className="
                w-full
                rounded-xl
                bg-blue-600
                px-6
                py-3
                font-semibold
                text-white
                hover:bg-blue-700
                disabled:bg-gray-400
                disabled:cursor-not-allowed
              "
            >
              {isStarting
                ? "Starting Quiz..."
                : "Start Quiz"}
            </button>

          </div>

        </div>

      </div>

    </div>
  );
};


export default EnglishQuizStartScreen;